"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontClassNames = void 0;
var buildClassMap_1 = require("../utilities/buildClassMap");
var DefaultFontStyles_1 = require("../styles/DefaultFontStyles");
/**
 * {@docCategory FontClassNames}
 */
exports.FontClassNames = buildClassMap_1.buildClassMap(DefaultFontStyles_1.DefaultFontStyles);
//# sourceMappingURL=FontClassNames.js.map